import { Permission, PermissionName, PermissionTypes, DynamicPermission } from './typed-permissions';

export class AppPermissions {
    public static readonly AllPermissions = {
        Name: new PermissionName('All Permission'),
        Services: {
            Name: new PermissionName('Services'),
            Sale: {
                Name: new PermissionName('Sale'),
                SaleAccess: new Permission('Sale Access', PermissionTypes.ReadWriteDelete),
                MakePayment: new Permission('Make Payment', PermissionTypes.ReadWriteDelete),
                AssignTechnician: new Permission('Assign Technician', PermissionTypes.Boolean),
                CloseJobs: new Permission('Close W.I.P (Invoice)', PermissionTypes.Boolean),
                MaxLaborDiscount: new Permission('Labor Maximum Discount %', PermissionTypes.Text, '100', '0'),
                MaxPartsDiscount: new Permission('Parts Maximum Discount %', PermissionTypes.Text, '100', '0'),
                LoadAndIssueParts: new Permission('Load/Issue Parts on Job Cards', PermissionTypes.Boolean),
                LoadAndIssueServices: new Permission('Load/Issue Services on Job Cards', PermissionTypes.Boolean),

                SubletAccess: new Permission('Sublet Access', PermissionTypes.ReadWriteDelete),

                UnCheckLines: new Permission('Uncheck Lines', PermissionTypes.Boolean),
                CreditNote: new Permission('Issue Credit Notes', PermissionTypes.Boolean),

                SetPartPrice: new Permission('Modify Part Price', PermissionTypes.Boolean),

                SellPartsBelowCost: new Permission('Sell Parts Below Cost', PermissionTypes.Boolean),
            },
            PushFromVSModule: new Permission('Push From VS Module', PermissionTypes.Boolean),
            Statuses: {
                Name: new PermissionName('Statuses'),
                JobCard: new Permission('Job Card', PermissionTypes.Boolean),
                WIP: new Permission('W.I.P', PermissionTypes.Boolean),
                PaymentDue: new Permission('Payment Due', PermissionTypes.Boolean),
                JobHistory: new Permission('Job History', PermissionTypes.Boolean),
            },
        },
        Parts: {
            Name: new PermissionName('Parts'),
            Order: new Permission('Order', PermissionTypes.ReadWriteDelete),
            ReceiveOrders: new Permission('Receive Orders', PermissionTypes.Boolean),
            Purchase: new Permission('Purchase', PermissionTypes.ReadWriteDelete),
            Stock: new Permission('Stock', PermissionTypes.ReadWriteDelete),
            Backorder: new Permission('Backorder', PermissionTypes.ReadWrite),
            Sale: {
                Name: new PermissionName('Sale'),
                SaleAccess: new Permission('Sale Access', PermissionTypes.ReadWriteDelete),
                MakePayment: new Permission('Make Payment', PermissionTypes.ReadWriteDelete),
                CloseJobs: new Permission('Close W.I.P (Invoice)', PermissionTypes.Boolean),
                MaxDiscount: new Permission('Maximum Discount %', PermissionTypes.Text, '100', '0'),

                UnCheckLines: new Permission('Uncheck Lines', PermissionTypes.Boolean),
                CreditNote: new Permission('Issue Credit Notes', PermissionTypes.Boolean),

                SetPartPrice: new Permission('Modify Part Price', PermissionTypes.Boolean),

                SellPartsBelowCost: new Permission('Sell Parts Below Cost', PermissionTypes.Boolean),
            },
            SaleMethods: {
                Name: new PermissionName('Sale Methods'),
                Retail: new Permission('Retail', PermissionTypes.ReadWriteDelete),
                Wholesale: new Permission('Wholesale', PermissionTypes.ReadWriteDelete),
            },
            Statuses: {
                Name: new PermissionName('Statuses'),
                WIP: new Permission('W.I.P', PermissionTypes.Boolean),
                PaymentDue: new Permission('Payment Due', PermissionTypes.Boolean),
                InvoiceHistory: new Permission('Invoice History', PermissionTypes.Boolean),
            },
            ChangePrice: new Permission('Change Parts Price', PermissionTypes.Boolean),
            PartCost: new Permission('Part Cost', PermissionTypes.Boolean),
        },
        VehicleSales: {
            Name: new PermissionName('Vehicle Sales'),
            //VehicleSalesAccess: new Permission('Vehicle Sales Access', PermissionTypes.ReadWriteDelete),
            KPIAccess: new Permission('KPI Access', PermissionTypes.ReadWrite),
            Ordering: new Permission('Ordering', PermissionTypes.ReadWriteDelete),
            Sales: {
                Name: new PermissionName('Sales'),
                Bulk: new Permission('Bulk', PermissionTypes.ReadWriteDelete),
                Retail: new Permission('Retail', PermissionTypes.ReadWriteDelete),
                MakePayment: new Permission('Make Payment', PermissionTypes.ReadWriteDelete),
                ChangeRetailSale: new Permission('Change Retail Sale Price', PermissionTypes.Boolean),
                CreditNote: new Permission('Change Retail Sale Price', PermissionTypes.Boolean),
            },
            Stock: {
                Name: new PermissionName('Stock'),
                StockCard: new Permission('Stock', PermissionTypes.ReadWriteDelete),
                Cost: new Permission('Cost', PermissionTypes.ReadWriteDelete),
                Pricing: new Permission('Pricing', PermissionTypes.ReadWrite),
                InsertInitialStock: new Permission('Insert Initial Stock', PermissionTypes.Boolean)
            },
            History: new Permission('History', PermissionTypes.Read),

            Receiving: new Permission('Receiving', PermissionTypes.ReadWriteDelete),
            Transfer: new Permission('Transfers', PermissionTypes.ReadWriteDelete),
        },
        Accounts: {
            Name: new PermissionName('Accounts'),
            Expenses: new Permission('Expenses', PermissionTypes.ReadWriteDelete),
            Customers: new Permission('Customers', PermissionTypes.ReadWriteDelete),
            Suppliers: new Permission('Supliers', PermissionTypes.ReadWriteDelete),
            SupplierPayments: new Permission('Supplier Payments', PermissionTypes.ReadWrite),
        },
        CRM: {
            Name: new PermissionName('CRM'),
            CRMAccess: new Permission('CRM Access', PermissionTypes.Boolean),
            SeeAllTasks: new Permission('See All Tasks', PermissionTypes.Boolean),
            AssignAndUnAssignVehicles: new Permission('Assign/UnAssign Vehicles', PermissionTypes.Boolean),
        },
        Settings: {
            Name: new PermissionName('Settings'),
            Users: new Permission('Users', PermissionTypes.ReadWriteDelete),
            Roles: new Permission('Roles', PermissionTypes.ReadWriteDelete),
            Translation:new Permission('Translation', PermissionTypes.Boolean)
        },
        DataLevelAccess: {
            Name: new PermissionName('Data Level Access'),
            ByBranch: new DynamicPermission('By Branch', PermissionTypes.ReadWriteDelete),
            WIPsByLedger: new DynamicPermission('WIPs by Ledger', PermissionTypes.Read),
        },
        APIs: {
            Name: new PermissionName('APIs'),
            Services: {
                Name: new PermissionName('Services'),
                UploadMenus: new Permission('Upload Menus', PermissionTypes.Boolean),
            },
        }
    };
};
